export default "__VITE_ASSET__Bp5vs7X6__"